import * as React from 'react';

interface ITabContentProps {
  isActive?: boolean;
}

interface ITabContentState {}

export default class TabContent extends React.Component<ITabContentProps, ITabContentState> {
  render() {
    return (
      <div className={`tab-content ${this.props.isActive ? 'tab-content--active' : ''}`}>
        {this.props.isActive ? this.props.children : null}
      </div>
    );
  }
}
